import classNames from "classnames";
import { components, DropdownIndicatorProps, GroupBase } from "react-select";

import { ReactComponent as Icon } from "./icons/arrow.svg";

import styles from "./style.module.scss";

export function DropdownIndicator<Option, IsMulti extends boolean, Group extends GroupBase<Option>>
({ className, children, ...props }: DropdownIndicatorProps<Option, IsMulti, Group>) {
  return (
    <components.DropdownIndicator {...props} className={classNames(className, styles.root)}>
      {children || <Icon />}
    </components.DropdownIndicator>
  );
}